/**
 * Audio tags ("[laughs]", "[sighs]") an agent on an expressive ElevenLabs voice writes
 * inline: the voice performs them, and the stored message keeps them, but a person reading
 * the conversation should read what was said. Same definition as the backend's
 * `platform/speech/audio-tags.ts`: letters, spaces, apostrophes and hyphens between square
 * brackets, 40 characters at most — a bracket carrying a digit ("[1]") is not a tag.
 */
const TAG_ANYWHERE = /\s*\[[\p{L}][\p{L}' -]{0,39}\]/gu;

/** An audio tag still being streamed in: "[lau" at the very end of the text. */
const PARTIAL_TAG_AT_END = /\s*\[[\p{L}' -]{0,39}$/u;

/** `text` without its audio tags: "Ah [laughs] oui." → "Ah oui.". */
export const stripAudioTags = (text: string): string => {
  if (!text || !text.includes("[")) return text;
  return text.replace(TAG_ANYWHERE, "").replace(/^\s+/, "");
};

/**
 * Same, for a reply that is still streaming in: a tag cut by the stream ("Ah [lau") is
 * hidden until it closes, rather than flashing on screen for a chunk.
 */
export const stripAudioTagsStreaming = (text: string): string =>
  stripAudioTags(text).replace(PARTIAL_TAG_AT_END, "");
